import { RaceType, ExperienceLevel, PlanPhase, WeeklyVolumeGuideline } from '../../types/athlete';

const VOLUME_GUIDELINES: WeeklyVolumeGuideline[] = [
  // Ironman
  { race_type: 'ironman', experience_level: 'beginner', phase: 'Base 1', swim_hours: 1.5, bike_hours: 5, run_hours: 3, strength_sessions: 2 },
  { race_type: 'ironman', experience_level: 'beginner', phase: 'Base 2', swim_hours: 2, bike_hours: 7, run_hours: 4, strength_sessions: 2 },
  { race_type: 'ironman', experience_level: 'beginner', phase: 'Build 1', swim_hours: 2.5, bike_hours: 9, run_hours: 5, strength_sessions: 2 },
  { race_type: 'ironman', experience_level: 'beginner', phase: 'Build 2', swim_hours: 3, bike_hours: 10, run_hours: 5.5, strength_sessions: 1 },
  { race_type: 'ironman', experience_level: 'beginner', phase: 'Peak', swim_hours: 2.5, bike_hours: 8, run_hours: 4, strength_sessions: 1 },
  { race_type: 'ironman', experience_level: 'intermediate', phase: 'Base 1', swim_hours: 2, bike_hours: 7, run_hours: 4, strength_sessions: 2 },
  { race_type: 'ironman', experience_level: 'intermediate', phase: 'Base 2', swim_hours: 3, bike_hours: 10, run_hours: 5, strength_sessions: 2 },
  { race_type: 'ironman', experience_level: 'intermediate', phase: 'Build 1', swim_hours: 3.5, bike_hours: 12, run_hours: 6, strength_sessions: 2 },
  { race_type: 'ironman', experience_level: 'intermediate', phase: 'Build 2', swim_hours: 4, bike_hours: 14, run_hours: 6.5, strength_sessions: 1 },
  { race_type: 'ironman', experience_level: 'intermediate', phase: 'Peak', swim_hours: 3, bike_hours: 11, run_hours: 5, strength_sessions: 1 },
  { race_type: 'ironman', experience_level: 'advanced', phase: 'Base 1', swim_hours: 2.5, bike_hours: 9, run_hours: 5, strength_sessions: 3 },
  { race_type: 'ironman', experience_level: 'advanced', phase: 'Base 2', swim_hours: 3.5, bike_hours: 12, run_hours: 6, strength_sessions: 3 },
  { race_type: 'ironman', experience_level: 'advanced', phase: 'Build 1', swim_hours: 4, bike_hours: 15, run_hours: 7, strength_sessions: 2 },
  { race_type: 'ironman', experience_level: 'advanced', phase: 'Build 2', swim_hours: 4.5, bike_hours: 17, run_hours: 7.5, strength_sessions: 2 },
  { race_type: 'ironman', experience_level: 'advanced', phase: 'Peak', swim_hours: 3.5, bike_hours: 13, run_hours: 6, strength_sessions: 1 },
  // 70.3
  { race_type: '70.3', experience_level: 'beginner', phase: 'Base', swim_hours: 1.5, bike_hours: 4, run_hours: 2.5, strength_sessions: 2 },
  { race_type: '70.3', experience_level: 'beginner', phase: 'Build', swim_hours: 2, bike_hours: 5.5, run_hours: 3.5, strength_sessions: 2 },
  { race_type: '70.3', experience_level: 'beginner', phase: 'Peak', swim_hours: 2.5, bike_hours: 6, run_hours: 4, strength_sessions: 1 },
  { race_type: '70.3', experience_level: 'intermediate', phase: 'Base', swim_hours: 2, bike_hours: 6, run_hours: 3.5, strength_sessions: 2 },
  { race_type: '70.3', experience_level: 'intermediate', phase: 'Build', swim_hours: 2.5, bike_hours: 8, run_hours: 4.5, strength_sessions: 2 },
  { race_type: '70.3', experience_level: 'intermediate', phase: 'Peak', swim_hours: 3, bike_hours: 9, run_hours: 5, strength_sessions: 1 },
  { race_type: '70.3', experience_level: 'advanced', phase: 'Base', swim_hours: 2.5, bike_hours: 8, run_hours: 4.5, strength_sessions: 3 },
  { race_type: '70.3', experience_level: 'advanced', phase: 'Build', swim_hours: 3, bike_hours: 10, run_hours: 5.5, strength_sessions: 2 },
  { race_type: '70.3', experience_level: 'advanced', phase: 'Peak', swim_hours: 3.5, bike_hours: 11, run_hours: 6, strength_sessions: 1 },
  // Olympic
  { race_type: 'olympic', experience_level: 'beginner', phase: 'Base', swim_hours: 1.5, bike_hours: 4, run_hours: 2, strength_sessions: 2 },
  { race_type: 'olympic', experience_level: 'beginner', phase: 'Build', swim_hours: 2, bike_hours: 5, run_hours: 3, strength_sessions: 2 },
  { race_type: 'olympic', experience_level: 'beginner', phase: 'Peak', swim_hours: 2, bike_hours: 5.5, run_hours: 3.5, strength_sessions: 1 },
  { race_type: 'olympic', experience_level: 'intermediate', phase: 'Base', swim_hours: 2, bike_hours: 5, run_hours: 3, strength_sessions: 2 },
  { race_type: 'olympic', experience_level: 'intermediate', phase: 'Build', swim_hours: 2.5, bike_hours: 7, run_hours: 4, strength_sessions: 2 },
  { race_type: 'olympic', experience_level: 'intermediate', phase: 'Peak', swim_hours: 2.5, bike_hours: 7.5, run_hours: 4.5, strength_sessions: 1 },
  // Sprint
  { race_type: 'sprint', experience_level: 'beginner', phase: 'Build', swim_hours: 1, bike_hours: 2.5, run_hours: 1.5, strength_sessions: 2 },
  { race_type: 'sprint', experience_level: 'beginner', phase: 'Peak', swim_hours: 1.5, bike_hours: 3, run_hours: 2, strength_sessions: 1 },
  { race_type: 'sprint', experience_level: 'intermediate', phase: 'Build', swim_hours: 1.5, bike_hours: 3.5, run_hours: 2, strength_sessions: 2 },
  { race_type: 'sprint', experience_level: 'intermediate', phase: 'Peak', swim_hours: 1.5, bike_hours: 4, run_hours: 2.5, strength_sessions: 1 },
];

export const getVolumeGuideline = (
  raceType: RaceType,
  experienceLevel: ExperienceLevel,
  phase: PlanPhase
): WeeklyVolumeGuideline => {
  const normalizedPhase = normalizePhaseName(phase);
  
  const guideline = VOLUME_GUIDELINES.find(
    g => g.race_type === raceType && 
        g.experience_level === experienceLevel && 
        normalizePhaseName(g.phase as PlanPhase) === normalizedPhase
  );
  
  if (guideline) return guideline;
  
  const fallback = VOLUME_GUIDELINES.find(
    g => g.race_type === raceType && 
        g.experience_level === 'intermediate' && 
        normalizePhaseName(g.phase as PlanPhase) === normalizedPhase
  );
  
  if (fallback) return fallback;
  
  return {
    race_type: raceType,
    experience_level: experienceLevel,
    phase: normalizedPhase,
    swim_hours: 2,
    bike_hours: 5,
    run_hours: 3,
    strength_sessions: 2,
  };
};

const normalizePhaseName = (phase: PlanPhase): string => {
  const phaseMap: Record<string, string> = {
    'Base 1': 'Base 1',
    'Base 2': 'Base 2',
    'Build 1': 'Build 1',
    'Build 2': 'Build 2',
    'Peak': 'Peak',
    'Taper': 'Taper',
    'Base': 'Base',
    'Build': 'Build',
    'Peak (Taper)': 'Peak',
  };
  return phaseMap[phase] || phase;
};

export const calculateSessionDuration = (
  category: string,
  guideline: WeeklyVolumeGuideline,
  sessionsPerWeek: number,
  isLongSession: boolean = false
): number => {
  const disciplineMap: Record<string, keyof WeeklyVolumeGuideline> = {
    'swim': 'swim_hours',
    'bike': 'bike_hours',
    'run': 'run_hours',
    'strength': 'strength_sessions',
  };
  
  const hoursKey = disciplineMap[category];
  if (!hoursKey) return 45;
  
  const totalHours = Number(guideline[hoursKey]);
  
  if (category === 'strength') {
    return Math.round((totalHours / sessionsPerWeek) * 60);
  }
  
  const minutesPerSession = (totalHours * 60) / sessionsPerWeek;
  
  if (isLongSession) {
    return Math.round(minutesPerSession * 2);
  }
  
  return Math.round(minutesPerSession);
};

export const getTotalWeeklyMinutes = (
  sessions: { discipline: string; duration: number }[]
): { swim: number; bike: number; run: number; strength: number; total: number } => {
  const totals = { swim: 0, bike: 0, run: 0, strength: 0, total: 0 };
  
  sessions.forEach(s => {
    const key = s.discipline as keyof typeof totals;
    if (key in totals) {
      totals[key] += s.duration;
      totals.total += s.duration;
    }
  });
  
  return totals;
};

export const formatDuration = (minutes: number): string => {
  if (minutes < 60) {
    return `${minutes} min`;
  }
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (mins === 0) {
    return `${hours} hr`;
  }
  return `${hours}h ${mins}m`;
};

export const calculateWeeklyVolumeSummary = (
  sessions: { discipline: string; duration: number }[]
): { label: string; value: number; color: string }[] => {
  const totals = getTotalWeeklyMinutes(sessions);
  
  const disciplines = [
    { key: 'swim' as const, label: 'Swim', color: 'blue' },
    { key: 'bike' as const, label: 'Bike', color: 'green' },
    { key: 'run' as const, label: 'Run', color: 'orange' },
    { key: 'strength' as const, label: 'Strength', color: 'purple' },
  ];
  
  return disciplines
    .filter(d => totals[d.key] > 0)
    .map(d => ({
      label: `${d.label}: ${formatDuration(totals[d.key])}`,
      value: totals[d.key],
      color: d.color,
    }));
};
